import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c60d740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-container f1 fv" }
const _hoisted_2 = {
  class: "fh-c-b",
  style: {"height":"11.7%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "人员状态分布图", -1))
const _hoisted_4 = { class: "fs12 color-06" }
const _hoisted_5 = {
  class: "fv-s-b",
  style: {"height":"88.3%","padding-top":"10px"}
}
const _hoisted_6 = { class: "fh-c f1" }
const _hoisted_7 = { class: "fs12 color-06" }
const _hoisted_8 = { class: "f1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, "总人数: " + _toDisplayString(_ctx.total), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "f1 w100 fv",
          key: index
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.label) + "（" + _toDisplayString(item.value) + "）", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_progress, {
              "stroke-color": {from: '#0E42D2', to: '#52C5FF'},
              "stroke-width": 12,
              percent: item.value / _ctx.total * 100,
              "trail-color": "var(--progress-color)",
              showInfo: false
            }, null, 8, ["percent"])
          ])
        ]))
      }), 128))
    ])
  ]))
}